<template>
  <div class="w-full max-w-sm font-proxima bg-white shadow-sm ring-1 ring-black ring-opacity-5 rounded-sm">
    <div class="px-4 py-2 bg-red-50 border-b border-gray-300">
      <p class="text-sm font-bold text-black">Fund Ledger Snapshot</p>
    </div>
    <div class="px-4 py-3">
      <p class="text-xs text-gray-500">Current Balance</p>
      <p class="text-2xl font-bold text-black">{{ money(output?.currentBalanceUsd) }}</p>
      <dl class="mt-3 divide-y divide-gray-200">
        <div v-for="line in lines" :key="line.label" class="flex justify-between py-1.5 text-sm">
          <dt class="text-gray-600">{{ line.label }}</dt>
          <dd class="text-black">{{ money(line.value) }}</dd>
        </div>
      </dl>
    </div>
  </div>
</template>
<script setup lang="ts">
interface FundSnapshot {
  initialAllocationUsd?: number;
  allocationAdjustmentsUsd?: number;
  currentAllocationUsd?: number;
  issuedPaymentsUsd?: number;
  pendingPaymentsUsd?: number;
  currentBalanceUsd?: number;
  unspentBalanceUsd?: number;
}

const props = defineProps<{ part: { output?: FundSnapshot } }>();

const output = computed(() => props.part.output);

// Values arrive pre-converted to dollars (see get_fund_ledger_snapshot selectResult)
const money = (usd?: number) => (usd == null ? '—' : formatNumberToMoney(usd));

const lines = computed(() => [
  { label: 'Initial Allocation', value: output.value?.initialAllocationUsd },
  { label: 'Allocation Adjustments', value: output.value?.allocationAdjustmentsUsd },
  { label: 'Current Allocation', value: output.value?.currentAllocationUsd },
  { label: 'Issued Payments', value: output.value?.issuedPaymentsUsd },
  { label: 'Pending Payments', value: output.value?.pendingPaymentsUsd },
  { label: 'Unspent Balance', value: output.value?.unspentBalanceUsd },
]);
</script>
